// SACRVM brand + i18n content. Single source of truth.
export const BRAND = {
  name: "SACRVM",
  fullName: "Mezcal SACRVM",
  tagline: {
    es: "El arte del mezcal, creado para trascender.",
    en: "The art of mezcal, crafted to transcend.",
  },
  whatsappNumber: "524442049874",
  email: "contacto@mezcalsacrvm.com",
  location: "Oaxaca, México",
  socials: {
    instagram: "https://instagram.com/sacrvm",
    facebook: "https://facebook.com/sacrvm",
  },
};

// Curated, verified agave / mezcal / Mexico imagery (Unsplash + Pexels, all confirmed 200).
export const IMAGES = {
  hero: "https://images.pexels.com/photos/16360721/pexels-photo-16360721.jpeg",
  heroAlt: "https://images.unsplash.com/photo-1706888135824-20ec9010b7bc?auto=format&fit=crop&w=2400&q=80",
  bottle1: "https://images.pexels.com/photos/7253705/pexels-photo-7253705.jpeg", // amber pour
  bottle2: "https://images.unsplash.com/photo-1633209174553-870cdca1cfd0?auto=format&fit=crop&w=1600&q=80", // large agave field
  bottle3: "https://images.unsplash.com/photo-1632883199436-b4148e338609?auto=format&fit=crop&w=1400&q=80", // close-up agave
  bottle4: "https://images.unsplash.com/photo-1649451994680-acaaf3341d00?auto=format&fit=crop&w=1400&q=80", // agave against wall
  agaveField: "https://images.unsplash.com/photo-1706888135824-20ec9010b7bc?auto=format&fit=crop&w=1600&q=80",
  agaveField2: "https://images.unsplash.com/photo-1634130132261-3bdf61051454?auto=format&fit=crop&w=1600&q=80",
  jimador: "https://images.unsplash.com/photo-1583184442258-1ae42ba36ebc?auto=format&fit=crop&w=1400&q=80",
  copperStill: "https://images.pexels.com/photos/7253705/pexels-photo-7253705.jpeg",
  barrels: "https://images.unsplash.com/photo-1516997121675-4c2d1684aa3e?auto=format&fit=crop&w=1600&q=80",
  glass: "https://images.unsplash.com/photo-1459664018906-085c36f472af?auto=format&fit=crop&w=1400&q=80",
  labelDetail: "https://images.unsplash.com/photo-1706888135824-20ec9010b7bc?auto=format&fit=crop&w=1400&q=80",
  oaxaca: "https://images.pexels.com/photos/16360721/pexels-photo-16360721.jpeg",
  tahona: "https://images.unsplash.com/photo-1578210423978-67ca8122eeda?auto=format&fit=crop&w=1400&q=80",
  smoke: "https://images.unsplash.com/photo-1694923963403-2443a0215818?auto=format&fit=crop&w=1600&q=80",
  pourGlass: "https://images.pexels.com/photos/7253705/pexels-photo-7253705.jpeg",
  agaveClose: "https://images.unsplash.com/photo-1576003754536-7193a6589fae?auto=format&fit=crop&w=1400&q=80",
  agaveWide: "https://images.unsplash.com/photo-1643139174301-cdc5e366cf69?auto=format&fit=crop&w=1600&q=80",
};

export const T = {
  nav: {
    home: { es: "Inicio", en: "Home" },
    story: { es: "Nuestra Historia", en: "Our Story" },
    collection: { es: "Colección", en: "Collection" },
    privateLabel: { es: "Private Label", en: "Private Label" },
    process: { es: "Proceso", en: "Process" },
    gallery: { es: "Galería", en: "Gallery" },
    contact: { es: "Contacto", en: "Contact" },
  },
  hero: {
    overline: { es: "Casa Mezcalera · Oaxaca", en: "Mezcal House · Oaxaca" },
    lines: {
      es: ["El arte del mezcal,", "creado para", "trascender."],
      en: ["The art of mezcal,", "crafted to", "transcend."],
    },
    body: {
      es: "Cada botella de SACRVM representa generaciones de tradición, procesos artesanales y una visión contemporánea del mezcal mexicano. Elaboramos pequeños lotes de la más alta calidad y ayudamos a marcas de todo el mundo a crear su propio mezcal.",
      en: "Every bottle of SACRVM represents generations of tradition, artisan processes and a contemporary vision of Mexican mezcal. We craft small batches of the highest quality and help brands worldwide create their own mezcal.",
    },
    ctaCollection: { es: "Ver colección", en: "View collection" },
    ctaBrand: { es: "Crear mi marca", en: "Create my brand" },
    scroll: { es: "Desliza para descubrir", en: "Scroll to discover" },
  },
  philosophy: {
    overline: { es: "Nuestra Filosofía", en: "Our Philosophy" },
    title: {
      es: "No hacemos mezcal para todos.",
      en: "We don't craft mezcal for everyone.",
    },
    subtitle: {
      es: "Creamos experiencias para quienes entienden el verdadero valor de la artesanía.",
      en: "We create experiences for those who understand the true value of craft.",
    },
    chapters: [
      {
        n: "01",
        title: { es: "Tradición", en: "Tradition" },
        body: {
          es: "Generaciones de maestros mezcaleros oaxaqueños han perfeccionado un oficio que se hereda con paciencia. Cada gesto —desde la jima hasta el reposo— carga siglos de saber.",
          en: "Generations of Oaxacan master mezcaleros have perfected a craft passed down with patience. Every gesture —from the jima to the rest— carries centuries of knowledge.",
        },
      },
      {
        n: "02",
        title: { es: "Respeto por el agave", en: "Respect for the agave" },
        body: {
          es: "Seleccionamos plantas maduras de entre siete y catorce años. Cada agave llega en su punto exacto, cuando su corazón concentra el azúcar y el carácter que define nuestro mezcal.",
          en: "We select mature plants between seven and fourteen years old. Each agave arrives at its precise moment, when its heart holds the sugars and character that define our mezcal.",
        },
      },
      {
        n: "03",
        title: { es: "Pequeños lotes", en: "Small batches" },
        body: {
          es: "Producciones limitadas. Trazabilidad total. Ningún lote comparte historia con el siguiente: cada uno es una firma irrepetible del tiempo, la tierra y la mano que lo elaboró.",
          en: "Limited productions. Full traceability. No batch shares its story with the next: each is an irrepeatable signature of time, land and the hand that made it.",
        },
      },
      {
        n: "04",
        title: { es: "Excelencia sin ruido", en: "Excellence without noise" },
        body: {
          es: "Lujo silencioso: menos ornamento, más precisión. La calidad se percibe en la copa antes de leerse en la etiqueta.",
          en: "Quiet luxury: less ornament, more precision. Quality is felt in the glass before it is read on the label.",
        },
      },
    ],
  },
  marquee: {
    es: ["Artesanal", "Pequeños Lotes", "Oaxaca", "Agave Espadín", "Tradición", "Trascender", "Private Label", "Exportación"],
    en: ["Artisanal", "Small Batches", "Oaxaca", "Agave Espadín", "Tradition", "Transcend", "Private Label", "Export"],
  },
  collection: {
    overline: { es: "La Colección", en: "The Collection" },
    title: { es: "Ediciones limitadas.", en: "Limited editions." },
    subtitle: {
      es: "Cuatro expresiones. Cuatro capítulos de una misma tierra.",
      en: "Four expressions. Four chapters of one land.",
    },
    cta: { es: "Solicitar información", en: "Request information" },
    products: [
      {
        slug: "espadin",
        name: "SACRVM Espadín",
        agave: { es: "Agave Espadín (Angustifolia)", en: "Agave Espadín (Angustifolia)" },
        abv: "40.0% Alc. Vol.",
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/td7y6b4o_Shoduba%20Negro.webp",
        fit: "contain",
        bg: "#000000",
        desc: {
          es: "El corazón de la casa. Notas ahumadas, cítricas y minerales. Un mezcal ceremonial que abre la conversación.",
          en: "The house's heart. Smoky, citrus and mineral notes. A ceremonial mezcal that opens the conversation.",
        },
      },
      {
        slug: "tobala",
        name: "SACRVM Ensamble",
        agave: { es: "Agave Espadín y Madrecuishe", en: "Espadín & Madrecuishe agaves" },
        abv: "40.0% Alc. Vol.",
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/c6hzjvhq_Sacrvm%20Ensamble%20Negro.png",
        fit: "contain",
        bg: "#000000",
        desc: {
          es: "Lo mejor de dos mundos capturado en una sola botella.",
          en: "The best of two worlds captured in a single bottle.",
        },
      },
      {
        slug: "madrecuixe",
        name: "SACRVM Madrecuishe",
        agave: { es: "Agave Madrecuishe (Karwinskii)", en: "Agave Madrecuishe (Karwinskii)" },
        abv: "40.0% Alc. Vol.",
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/88l8f457_Sacrvm%2040%20Negro.png",
        fit: "contain",
        bg: "#000000",
        desc: {
          es: "Agave silvestre. Ahumado y con cuerpo.",
          en: "Wild agave. Smoky and full-bodied.",
        },
      },
      {
        slug: "ancestral",
        name: "SACRVM Madrecuishe 48",
        agave: { es: "Agave Madrecuishe (Karwinskii)", en: "Agave Madrecuishe (Karwinskii)" },
        abv: "48.0% Alc. Vol.",
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/9h6yn8vd_sacrvm%2048%20Negro.webp",
        fit: "contain",
        bg: "#000000",
        desc: {
          es: "Destilado a fuego lento. Textura densa, humo profundo y final largo.",
          en: "Distilled over slow fire. Dense texture, deep smoke and long finish.",
        },
      },
    ],
  },
  twoPaths: {
    overline: { es: "Dos caminos, una excelencia", en: "Two paths, one excellence" },
    left: {
      title: { es: "Comprar SACRVM", en: "Buy SACRVM" },
      body: {
        es: "Mezcales artesanales premium para consumidores, restaurantes, hoteles, distribuidores y regalos corporativos.",
        en: "Premium artisan mezcals for consumers, restaurants, hotels, distributors and corporate gifting.",
      },
      cta: { es: "Ver colección", en: "View collection" },
    },
    right: {
      title: { es: "Desarrolla tu marca", en: "Develop your brand" },
      body: {
        es: "Servicio integral llave en mano para empresas y emprendedores que desean lanzar su propia marca de mezcal.",
        en: "Turnkey end-to-end service for companies and entrepreneurs launching their own mezcal brand.",
      },
      cta: { es: "Conocer Private Label", en: "Explore Private Label" },
    },
  },
  privateLabel: {
    overline: { es: "Private Label · Maquila", en: "Private Label · OEM" },
    titleLines: {
      es: ["Tu marca.", "Nuestra experiencia.", "Un mezcal excepcional."],
      en: ["Your brand.", "Our expertise.", "An exceptional mezcal."],
    },
    body: {
      es: "Desarrollamos marcas privadas de mezcal artesanal para empresas, restaurantes, hoteles, distribuidores, importadores y emprendedores que desean lanzar un producto premium sin construir una destilería. Servicio integral, de la selección del agave a la exportación.",
      en: "We develop private artisan mezcal brands for companies, restaurants, hotels, distributors, importers and entrepreneurs who want to launch a premium product without building a distillery. A full service, from agave selection to export.",
    },
    includes: {
      es: [
        "Producción artesanal",
        "Selección del agave",
        "Desarrollo de recetas",
        "Diseño de botella",
        "Diseño de etiqueta",
        "Registro NOM",
        "Registro de marca",
        "Envasado",
        "Empaque",
        "Logística nacional",
        "Exportación",
        "Consultoría comercial",
      ],
      en: [
        "Artisan production",
        "Agave selection",
        "Recipe development",
        "Bottle design",
        "Label design",
        "NOM registration",
        "Trademark registration",
        "Bottling",
        "Packaging",
        "Domestic logistics",
        "Export",
        "Commercial consulting",
      ],
    },
    steps: [
      { es: "Selección del Agave", en: "Agave Selection" },
      { es: "Producción Artesanal", en: "Artisan Production" },
      { es: "Destilación", en: "Distillation" },
      { es: "Diseño de Botella", en: "Bottle Design" },
      { es: "Diseño de Etiqueta", en: "Label Design" },
      { es: "Envasado", en: "Bottling" },
      { es: "Control de Calidad", en: "Quality Control" },
      { es: "Exportación", en: "Export" },
    ],
    cta: { es: "Solicitar cotización", en: "Request quotation" },
  },
  whyUs: {
    overline: { es: "Por qué SACRVM", en: "Why SACRVM" },
    title: { es: "Precisión, no ostentación.", en: "Precision, not ostentation." },
    items: [
      { es: "Producción artesanal certificada", en: "Certified artisan production" },
      { es: "Pequeños lotes trazables", en: "Traceable small batches" },
      { es: "Agaves seleccionados a mano", en: "Hand-picked agaves" },
      { es: "Control de calidad riguroso", en: "Rigorous quality control" },
      { es: "Experiencia internacional", en: "International expertise" },
      { es: "Servicio Private Label integral", en: "End-to-end Private Label" },
      { es: "Exportación multi-país", en: "Multi-country export" },
      { es: "Diseño premium a medida", en: "Bespoke premium design" },
      { es: "Flexibilidad total", en: "Full flexibility" },
      { es: "Acompañamiento de principio a fin", en: "End-to-end accompaniment" },
    ],
  },
  process: {
    overline: { es: "Proceso Artesanal", en: "Artisan Process" },
    title: {
      es: "Del agave a la copa.",
      en: "From the agave to the glass.",
    },
    steps: [
      {
        n: "I",
        title: { es: "Jima", en: "Jima" },
        body: {
          es: "El jimador corta las pencas y libera la piña madura. Un solo movimiento decide años de espera.",
          en: "The jimador cuts the leaves and frees the mature piña. A single motion decides years of waiting.",
        },
        image: "https://images.unsplash.com/photo-1583184442258-1ae42ba36ebc?auto=format&fit=crop&w=1600&q=80",
      },
      {
        n: "II",
        title: { es: "Horno de tierra", en: "Earth oven" },
        body: {
          es: "Las piñas se cocinan durante días bajo piedras volcánicas y leña. Aquí nace el humo.",
          en: "The piñas cook for days under volcanic stones and firewood. This is where the smoke is born.",
        },
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/lvxlj2g3_images%20%285%29.jpg",
      },
      {
        n: "III",
        title: { es: "Molienda en tahona", en: "Tahona milling" },
        body: {
          es: "Una piedra circular tirada por un caballo tritura la fibra. El método más antiguo, aún el más noble.",
          en: "A stone wheel pulled by a horse crushes the fiber. The oldest method, still the noblest.",
        },
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/vefxnv0l_unnamed.jpg",
      },
      {
        n: "IV",
        title: { es: "Destilación", en: "Distillation" },
        body: {
          es: "Doble destilación en alambiques de cobre. La forma del alambique escribe el carácter final.",
          en: "Double distillation in copper stills. The still's shape writes the final character.",
        },
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/p8gceejb_WhatsApp%20Image%202026-08-03%20at%2010.20.25.jpeg",
      },
    ],
  },
  gallery: {
    overline: { es: "Galería", en: "Gallery" },
    title: { es: "Un retrato editorial.", en: "An editorial portrait." },
  },
  counters: {
    overline: { es: "SACRVM en cifras", en: "SACRVM in numbers" },
    items: [
      { n: 25, suffix: "+", label: { es: "Años de tradición", en: "Years of tradition" } },
      { n: 180000, suffix: "+", label: { es: "Botellas producidas", en: "Bottles produced" } },
      { n: 140, suffix: "+", label: { es: "Clientes atendidos", en: "Clients served" } },
      { n: 22, suffix: "", label: { es: "Países alcanzados", en: "Countries reached" } },
    ],
  },
  testimonials: {
    overline: { es: "Voces", en: "Voices" },
    title: {
      es: "Lo que dicen quienes ya trabajan con nosotros.",
      en: "What those who already work with us say.",
    },
    items: [
      {
        quote: {
          es: "SACRVM entendió nuestra visión antes de que la termináramos de explicar. El resultado superó cualquier mezcal que hayamos importado.",
          en: "SACRVM understood our vision before we finished explaining it. The result surpassed any mezcal we've ever imported.",
        },
        author: "Maison Auréline",
        role: { es: "Importador · París, Francia", en: "Importer · Paris, France" },
      },
      {
        quote: {
          es: "El nivel de detalle en cada botella se siente. Nuestros huéspedes lo notan desde el primer sorbo.",
          en: "The level of detail in every bottle can be felt. Our guests notice from the first sip.",
        },
        author: "Casa Selene Resorts",
        role: { es: "Grupo Hotelero · Los Cabos", en: "Hotel Group · Los Cabos" },
      },
      {
        quote: {
          es: "Nos ayudaron a lanzar nuestra propia marca de mezcal en menos tiempo del que imaginamos. Servicio de otro nivel.",
          en: "They helped us launch our own mezcal brand in less time than we imagined. Next-level service.",
        },
        author: "Nikkei & Fuego",
        role: { es: "Grupo Restaurantero · CDMX", en: "Restaurant Group · Mexico City" },
      },
    ],
  },
  gifting: {
    overline: { es: "Regalos Corporativos", en: "Corporate Gifting" },
    title: { es: "Un obsequio que se recuerda.", en: "A gift that is remembered." },
    body: {
      es: "Empaques a medida, botellas grabadas y ediciones exclusivas para clientes, socios, bodas y experiencias de marca. Elevamos cada entrega con papel de algodón, sellos en dorado y cajas rígidas fabricadas en México.",
      en: "Bespoke packaging, engraved bottles and exclusive editions for clients, partners, weddings and brand experiences. We elevate every delivery with cotton paper, gold foil stamps and rigid boxes crafted in Mexico.",
    },
    perks: [
      { es: "Grabado láser en botella", en: "Laser engraving on bottle" },
      { es: "Caja rígida con hot-stamping", en: "Rigid box with hot-stamping" },
      { es: "Tarjeta editorial personalizada", en: "Custom editorial card" },
      { es: "Selección de expresión por lote", en: "Expression selection per batch" },
      { es: "Entrega nacional e internacional", en: "Domestic & international delivery" },
      { es: "Numeración a mano por unidad", en: "Hand-numbered per unit" },
    ],
    cta: { es: "Solicitar propuesta", en: "Request a proposal" },
  },
  distributors: {
    overline: { es: "Distribuidores · Importadores", en: "Distributors · Importers" },
    title: {
      es: "Alianzas a largo plazo. Estándares de casa mezcalera.",
      en: "Long-term partnerships. Mezcal-house standards.",
    },
    body: {
      es: "Trabajamos con distribuidores e importadores selectos que comparten nuestro estándar de calidad. Ofrecemos precios de casa, materiales de marketing dedicados y acompañamiento en cada mercado.",
      en: "We work with select distributors and importers who share our quality standard. We offer house pricing, dedicated marketing materials and market-by-market support.",
    },
    regions: [
      { es: "Norteamérica", en: "North America" },
      { es: "Europa", en: "Europe" },
      { es: "Asia-Pacífico", en: "Asia-Pacific" },
      { es: "América Latina", en: "Latin America" },
      { es: "Medio Oriente", en: "Middle East" },
      { es: "Duty-Free & Travel Retail", en: "Duty-Free & Travel Retail" },
    ],
    fields: {
      companyType: { es: "Tipo de operación", en: "Operation type" },
      region: { es: "Región de interés", en: "Region of interest" },
      channels: { es: "Canales que atienden", en: "Channels you serve" },
    },
    submit: { es: "Solicitar información B2B", en: "Request B2B information" },
    success: { es: "Recibimos tu solicitud. Nuestro equipo internacional te contactará.", en: "We received your request. Our international team will contact you." },
  },
  faq: {
    overline: { es: "Preguntas", en: "Questions" },
    title: { es: "Lo que otros clientes ya preguntaron.", en: "What other clients have asked." },
    items: [
      {
        q: { es: "¿Qué tipos de agave manejan?", en: "Which agaves do you work with?" },
        a: { es: "Espadín, Tobalá, Madrecuishe, Cuishe, Tepeztate y ensambles ancestrales. También trabajamos agaves cultivados y silvestres según el perfil buscado.", en: "Espadín, Tobalá, Madrecuishe, Cuishe, Tepeztate and ancestral ensembles. We work with cultivated and wild agaves depending on the profile you need." },
      },
      {
        q: { es: "¿Realizan exportaciones?", en: "Do you export?" },
        a: { es: "Sí. Contamos con experiencia y documentación para exportar a Estados Unidos, Europa, Asia y América Latina.", en: "Yes. We hold the expertise and documentation to export to the United States, Europe, Asia and Latin America." },
      },
      {
        q: { es: "¿Pueden fabricar mi marca?", en: "Can you manufacture my brand?" },
        a: { es: "Sí. Ofrecemos un servicio integral de Private Label: desde receta hasta exportación, incluyendo diseño, empaque y trámites.", en: "Yes. We offer a full Private Label service: from recipe to export, including design, packaging and paperwork." },
      },
      {
        q: { es: "¿Cuál es el pedido mínimo?", en: "What is the minimum order?" },
        a: { es: "El mínimo se define por proyecto. Trabajamos desde 1,200 botellas para ediciones limitadas y podemos escalar a lotes mayores.", en: "The minimum is defined per project. We start at 1,200 bottles for limited editions and can scale to larger batches." },
      },
      {
        q: { es: "¿Diseñan etiquetas?", en: "Do you design labels?" },
        a: { es: "Sí. Contamos con equipo de diseño premium: dirección de arte, tipografía a medida, litografía y acabados finos.", en: "Yes. We have an in-house premium design team: art direction, custom typography, lithography and fine finishes." },
      },
      {
        q: { es: "¿Ayudan con el registro NOM?", en: "Do you help with NOM registration?" },
        a: { es: "Sí. Gestionamos el registro NOM y de marca. Todo el trámite regulatorio queda cubierto.", en: "Yes. We handle NOM and trademark registration. The whole regulatory process is covered." },
      },
      {
        q: { es: "¿Pueden exportar a mi país?", en: "Can you export to my country?" },
        a: { es: "En la mayoría de los casos, sí. Escríbenos con tu mercado destino y evaluamos permisos, aranceles y logística.", en: "In most cases, yes. Write to us with your target market and we'll assess permits, tariffs and logistics." },
      },
    ],
  },
  contact: {
    overline: { es: "Contacto", en: "Contact" },
    title: { es: "Escríbenos.", en: "Write to us." },
    subtitle: {
      es: "Compartir un mezcal comienza con una conversación. Respondemos en menos de 24 horas.",
      en: "Sharing mezcal begins with a conversation. We reply within 24 hours.",
    },
    fields: {
      name: { es: "Nombre", en: "Name" },
      company: { es: "Empresa", en: "Company" },
      email: { es: "Correo", en: "Email" },
      country: { es: "País", en: "Country" },
      whatsapp: { es: "WhatsApp", en: "WhatsApp" },
      message: { es: "Mensaje", en: "Message" },
    },
    submit: { es: "Enviar mensaje", en: "Send message" },
    success: { es: "Recibimos tu mensaje. Pronto estaremos en contacto.", en: "We received your message. We'll be in touch soon." },
    error: { es: "No pudimos enviar tu mensaje. Intenta de nuevo.", en: "We couldn't send your message. Please try again." },
  },
  privateLabelForm: {
    overline: { es: "Private Label", en: "Private Label" },
    title: { es: "Cotiza tu propia marca.", en: "Quote your own brand." },
    subtitle: {
      es: "Cuéntanos tu proyecto. Nuestro equipo te contactará con una propuesta personalizada.",
      en: "Tell us about your project. Our team will contact you with a tailored proposal.",
    },
    fields: {
      volume: { es: "Volumen estimado (botellas)", en: "Estimated volume (bottles)" },
      market: { es: "Mercado destino", en: "Target market" },
    },
    submit: { es: "Solicitar cotización", en: "Request quotation" },
  },
  footer: {
    tagline: {
      es: "Casa mezcalera artesanal. Oaxaca, México.",
      en: "Artisan mezcal house. Oaxaca, Mexico.",
    },
    privacy: { es: "Aviso de privacidad", en: "Privacy notice" },
    rights: { es: "Todos los derechos reservados.", en: "All rights reserved." },
    responsibility: {
      es: "Bebe con moderación. Prohibida la venta a menores de edad.",
      en: "Drink responsibly. Sale prohibited to minors.",
    },
  },
};
